<template>
  <div id="map_canvas" />
</template>
<script>
import { listSchoolDependances } from '../../repositories/scholenRepository';

export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      video: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      if (!window.AppSettings.googleLoaded) {
        setTimeout(this.init, 1000);
        return;
      }

      const ele = document.getElementById('map_canvas');
      const map = new google.maps.Map(ele, {
        center: { lat: this.school.lat, lng: this.school.lon },
        styles,
        zoom: 15,
        scrollwheel: false,
      });

      const markers = [];
      const schoolMarker = new google.maps.Marker({
        position: { lat: this.school.lat, lng: this.school.lon },
        icon: `${process.env.VUE_APP_BASE_URL}/assets/img/icons/icon_big.png`,
        map,
      });
      markers.push(schoolMarker);

      let response;
      try {
        response = await listSchoolDependances({
          'where[school_id]': this.school.id,
        });
      } catch (err) {
        console.log(err);
        return;
      }
      for (const dep of response.data) {
        const depMarker = new google.maps.Marker({
          position: { lat: dep.lat, lng: dep.lon },
          icon: `${process.env.VUE_APP_BASE_URL}/assets/img/icons/icon_medium.png`,
          map,
        });
        markers.push(depMarker);
      }

      // const bounds = new google.maps.LatLngBounds();
      // for (const marker of markers) {
      //   bounds.extend(marker.getPosition());
      // }
      // map.fitBounds(bounds);
    },
  },
};

const styles = [
  {
    elementType: 'geometry',
    stylers: [{ color: '#9EB6C1' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#7C8F97' }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#CAE9F3' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#7C8F97' }],
  },
  {
    stylers: [{ saturation: 0 }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [{ visibility: 'on' }, { color: '#B7D2DB' }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [{ color: '#BAD5DF' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [{ color: '#B6D1DA' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#A4BDC4' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#CAE9F3' }],
  },
];
</script>
